<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="Mã đơn vị" placeholder="Tìm theo mã đơn vị" :initialValue="sValue_MADONVI"
                                v-model="sValue_MADONVI" :isRequire=false :key="tempKey" @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="Tên" placeholder="Tìm theo tên" :initialValue="sValue_TEN"
                                v-model="sValue_TEN" :isRequire=false :key="tempKey" @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">

                            <TheSelect title="Quận huyện" :options="category_QUANHUYEN" :initialValue="sValue_QUANHUYEN"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(v) => searchChangeQuanHuyen(v)" />

                        </div>
                        <div class="col mb-3">

                            <TheSelect title="Cấp đơn vị" :options="category_CAPDONVI" :initialValue="sValue_CAPDONVI"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(v) => searchChangeCapDonVi(v)" />
                        </div>

                        <div class="col mb-3">
                            <TheSelect title="Đơn vị cha" :options="category_DONVICHA" :initialValue="sValue_DONVICHA"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(v) => searchChangeDonViCha(v)" />
                        </div>
                        <div class="col mb-3">
                            <div class="form-group">
                                <label>
                                    <span>Hiển thị trên cổng</span>
                                </label>
                                <select id="enabled_sOptions" class="form-control select2bs4" style="width: 100%">
                                    <option :value=null>--- Tất cả ---</option>
                                    <option :value=true>Bật</option>
                                    <option :value=false>Tắt</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col50">
                                        Đơn vị ID
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('maDonVi')">
                                        Mã đơn vị
                                        <span v-if="(orderDesc == false && sortBy == 'maDonVi')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'maDonVi')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('tenDonVi')">
                                        Tên đơn vị
                                        <span v-if="(orderDesc == false && sortBy == 'tenDonVi')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'tenDonVi')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50">
                                        Tên đơn vị cha
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('tenQuanHuyen')">
                                        Tên quận huyện
                                        <span v-if="(orderDesc == false && sortBy == 'tenQuanHuyen')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'tenQuanHuyen')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('tenCapDonVi')">
                                        Cấp đơn vị
                                        <span v-if="(orderDesc == false && sortBy == 'tenCapDonVi')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'tenCapDonVi')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col10 cursor" @click="handleSortChange('stt')">
                                        STT
                                        <span v-if="(orderDesc == false && sortBy == 'stt')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'stt')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50">Hiển thị trên cổng</th>
                                    <th class="col50"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td></td>
                                    <td>{{ item.donViId }}</td>
                                    <td>{{ item.maDonVi }}</td>
                                    <td>{{ item.ten }}</td>
                                    <td>{{ item.tenDonViCha }}</td>
                                    <td>{{ item.tenQuanHuyen }}</td>
                                    <td>{{ item.tenCapDonVi }}</td>
                                    <td>{{ item.stt }}</td>
                                    <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                :id="'item' + item.appId" v-model="item.enabledDisplay" disabled="true">
                                            <label class="custom-control-label" :for="'item' + item.appId"></label>
                                        </div>
                                    </td>
                                    <td>
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="detail(item, 'detail')" title="Xem chi tiết">
                                            <i class="fas fa-eye text-secondary"></i>
                                        </button>&nbsp;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-success">Chi tiết</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupDetail">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" v-if="modelRec">
                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">

                                    <p class="text-sm">Đơn vị ID:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.donViId }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Mã đơn vị
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.maDonVi }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Tên đơn vị
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ten }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Tên tắt
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenTat }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Số điện thoại
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.sdt }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Đơn vị cha
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenDonViCha }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Quận huyện
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenQuanHuyen }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Cấp đơn vị
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenCapDonVi }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Ghi chú
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">STT
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                                    </p>

                                    <p class="text-sm">Hiển thị trên cổng:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ? "Có" : "Không"
                                            }}&nbsp;</b>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>


</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';

import { donViModel } from '@/models/quantri/donVi.model'

export default {
    name: "TheDonViQT",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,

            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadonly: null,

            modelRec: donViModel.newModel(),
            model: donViModel.newFEModel(),


            sValue_ID: null,
            sValue_MADONVI: null,
            sValue_TEN: null,
            sValue_QUANHUYEN: null,
            sValue_CAPDONVI: null,
            sValue_SORT: null,
            sValue_ENABLED: null,

            category_QUANHUYEN: [],
            category_CAPDONVI: [],
            category_DONVICHA: [],

            sType_List: 1,

            tempKey: common.randomString(10)
        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('donViQT', ['getPagingDonViQT', 'getDetailDonViQT', 'getBasicDonViChaQT']),
        ...mapActions('quanHuyenDM', ['getBasicQuanHuyenDM']),
        ...mapActions('capDonVi', ['getBasicCapDonVi']),
        async setup() {
            let header = 'Danh sách đơn vị'
            this.setupHeader({ header })
        },

        async initialize() {
            $('#enabled_sOptions').on('change', e => {
                let a = e.target.value
                let returnValue = null
                switch (a) {
                    case "true":
                        returnValue = true
                        break
                    case "false":
                        returnValue = false
                        break
                    default:
                        returnValue = null
                }
                this.sValue_ENABLED = returnValue
                this.handlePageChange(1)
            });
        },

        async showPopupDetail() {
            $('#detailModal').modal('show')
        },
        async hidePopupDetail() {
            $('#detailModal').modal('hide')
        },

        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.sValue_SORT = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },

        async changeCurrentTypeSearch() {
            if (this.sType_List == 2) this.sType_List = 1
            else if (this.sType_List == 1) this.sType_List = 2
            await this.handlePageChange(1)
        },


        async searchChangeQuanHuyen(e) {
            this.sValue_QUANHUYEN = e == "" ? null : e
            this.handlePageChange(1)
        },
        async searchChangeCapDonVi(e) {
            this.sValue_CAPDONVI = e == "" ? null : e
            this.handlePageChange(1)
        },
        async searchChangeDonViCha(e) {
            this.sValue_DONVICHA = e == "" ? null : e
            this.handlePageChange(1)
        },
        async getData() {
            this.isBusy = true
            let params = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                quanHuyenId: this.sValue_QUANHUYEN,
                capDonViId: this.sValue_CAPDONVI,
                maDonVi: this.sValue_MADONVI,
                donViChaId: this.sValue_DONVICHA,
                ten: this.sValue_TEN == "" ? null : this.sValue_TEN,
                sort: this.sValue_SORT,
                enabled: this.sValue_ENABLED,
            }
            await this.getPagingDonViQT({ params: params, type: this.sType_List }).then(res => {
                // List data
                this.items = res.data
                if (this.items) {
                    for (let i = 0; i < this.items.length; i++) {
                        this.items[i].enabledDisplay = this.items[i].enabled == 1 ? true : false
                    }
                }

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },

        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('labels.styleButton' + code)
            this.styleTitle = this.$t('labels.styleTitle' + code)

            if (this.code == 'detail') {
                let params = {
                    donViId: item.donViId
                }
                await this.getDetailDonViQT({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = donViModel.newModel()
                        this.modelRec = resp
                    }
                });
                this.tempKey = common.randomString(10)
                this.showPopupDetail()
            }
        },

        async getCategory_QUANHUYEN() {
            let params = {
                tinhTpId: config.TINHTP_SITEID
            }
            let res = await this.getBasicQuanHuyenDM({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].quanHuyenId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },

        async getCategory_CAPDONVI() {
            let params = {
            }
            let res = await this.getBasicCapDonVi({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].capDonViId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },

        async getCategory_DONVICHA() {
            let params = {
            }
            let res = await this.getBasicDonViChaQT({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].donViChaId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },


    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()

        this.category_QUANHUYEN = await this.getCategory_QUANHUYEN()
        this.category_CAPDONVI = await this.getCategory_CAPDONVI()
        this.category_DONVICHA = await this.getCategory_DONVICHA()
    }


}
</script>
<style></style>